import React from 'react'
import { Modal } from 'antd'
import { PreviewDraftEmailRequestDto } from '../../../api/dto/invoice-delivery.dto'
import { usePreviewDraftEmailQuery } from '../../../api/invoice-delivery-api-client'
import { toFriendlyFileName } from '../TruncatedFileName'
import { InvoiceEmailPreview } from './EmailPreviewCard'
import { INVOICE_TEMPLATE_CUSTOMER_LABELS } from './invoiceTemplates'
import {
  PreviewCaption,
  PreviewModalSubtitle,
  PreviewModalTitle,
} from './EmailPreview.styles'

interface UploadEmailPreviewModalProps {
  fileName: string
  companyName: string
  request: PreviewDraftEmailRequestDto
  onClose: () => void
}

/** The email a not-yet-uploaded file will get with its chosen template. */
const UploadEmailPreviewModal: React.FC<UploadEmailPreviewModalProps> = ({
  fileName,
  companyName,
  request,
  onClose,
}) => {
  const preview = usePreviewDraftEmailQuery(request)
  return (
    <Modal
      open
      onCancel={onClose}
      footer={null}
      width={680}
      destroyOnClose
      title={
        <PreviewModalTitle>
          Email preview
          <PreviewModalSubtitle>
            {INVOICE_TEMPLATE_CUSTOMER_LABELS[request.invoiceTemplate]} ·{' '}
            {toFriendlyFileName(fileName, companyName)}
          </PreviewModalSubtitle>
        </PreviewModalTitle>
      }
    >
      <PreviewCaption>
        Preview before upload. Amounts and dates can still be changed in the
        invoice&apos;s drawer afterwards.
      </PreviewCaption>
      <InvoiceEmailPreview companyName={companyName} preview={preview} />
    </Modal>
  )
}

export { UploadEmailPreviewModal }
